export default class ExternalSociety {
  constructor(society) {
    this.setData(society);
  }

  setData(society) {
    const defaultValue = {
      uuid: null,
      title: null,
      address_1: null,
      address_2: null,
      address_3: null,
      postal_code: null,
      cedex: null,
      tel: null,
      fax: null,
      email: null,
      national: null,
      siren: null,
      city: null,
      nic: null,
      from_old_rapso: null,
    };

    const well_formated_data = { ...defaultValue, ...society };

    for (let [key, value] of Object.entries(well_formated_data)) {
      this[key] = value;
    }
  }
}
